import React from 'react'

const Businesses = ({ data }) => {
    return (
        <div>
            <h4 className="heading">{data?.heading}</h4>
            {data?.paragraph?.map((item, index) => {
                return (
                    <div key={index} className='mb-3'>
                        <p className="paragraph m-0">{item?.para}<b>{item?.paraBold}</b>{item?.para1}</p>
                        {item?.listData?.length > 0 &&
                            <ul className="mt-3 page-custom-made-application-list">
                                {item.listData.map((li, liIndex) => {
                                    return (<li key={liIndex}>
                                        {li?.text && <p className="paragraph m-0"><b>{li?.boldText}</b>{li?.text} </p>}
                                    </li>
                                    )
                                })}
                            </ul>
                        }
                    </div>
                )
            })}
            <div>
            </div>
        </div>
    )
}
export default Businesses
